<template>
  <div class="row efw">
    <div class="col-md-12 form-group">
        <h5>{{caption}}<span v-show="required">*</span></h5>
        <slot></slot>
    </div>
  </div>
</template>

<script>


export default {
  name: 'edit-full-width',
  data () {
    return {
    }
  },
  methods: {
  },
  components: {
  },
  props: ['caption','required'],
  created: function() {
        }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.efw {
  margin-top: 15px;
}  
</style>



// WEBPACK FOOTER //
// edit-full-width.vue?d2e1ea0a